export default {
  topPanel: {
    title: 'Purchase applications for this month',
    quarter: 'Quarter on quarter',
    paneList: {
      totalRequest: 'Apply count',
      suppliers: 'Number of Suppliers',
      productCategory: 'Product Category',
      applicant: 'Number of Application',
      completionRate: 'Completion Rate(%)',
      arrivalRate: 'Arrival Rate(%)',
    },
  },
  procurement: {
    title: 'Trends in purchase requisitions for goods',
    goods: {
      cup: 'cup',
      tea: 'tea',
      honey: 'honey',
      flour: 'flour',
      coffeeMachine: 'coffee machine',
      massageMachine: 'massage machine',
    },
  },
  ssl: 'SSL certificate',
  sslDescription:
    'SSL certificate, also known as a server certificate, is a digital certificate that authenticates the identity of a website and encrypts information sent to the server using SSL technology. Beijing Yijiayuan Sports Technology Co., Ltd. provides a one-stop service for SSL certificates, including application, management, and deployment of both free and paid certificates.',
  satisfaction: {
    title: 'distribution of satisfaction levels for purchased goods',
    export: 'export data',
  },
  chart: {
    week1: 'MON',
    week2: 'TUE',
    week3: 'WED',
    week4: 'THU',
    week5: 'FRI',
    week6: 'SAT',
    week7: 'SUN',
    max: 'Max',
    min: 'Min',
    thisMonth: 'this month',
    lastMonth: 'last month',
  },
};
